import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';

@Component({
  selector: 'mc-review-package-confirm-complete-dialog',
  templateUrl: './review-package-confirm-complete-dialog.component.html',
  styleUrls: ['./review-package-confirm-complete-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewPackageConfirmCompleteDialogComponent extends DialogBase<ReviewPackageConfirmCompleteDialogComponent, boolean> {
  static DialogConfig: MatDialogConfig = {
    width: '55rem',
    height: '27rem'
  };

  constructor(
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<ReviewPackageConfirmCompleteDialogComponent, boolean>,
  ) {
    super(dialog, dialogRef);
  }
}
